module.exports = __webpack_public_path__ + "images/b74ece1a3440b97351050835b0046449.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/osuuspankki.png
// module id = 1524
// module chunks = 1